import React from "react";
import EventComponent from "../HomePage/Events";
import Style from '../Styles/Common.module.css';

const EventPage = ()=>{
    return(
        <div className={Style.pageTitle + ' ' + Style.eventPage + ' ' + Style.pageShoeComp}>
            <EventComponent />
        </div>
    )
}

export default EventPage;